<script lang="ts">
    import * as Dialog from "$lib/components/ui/dialog";
    import { Button } from "$lib/components/ui/button";
    import { isLoading, t  } from 'svelte-i18n'
    import { Trash2 } from 'lucide-svelte';
    import { useDeleteDocument } from "../hooks/useDeleteDocument";
    import { push } from "svelte-spa-router";
    import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
    import { ContextTokens } from "$src/presentation/contexts/ContextTokens";
    import { getContext } from "svelte";

    export let groupStoreId: number
	export let projectId: number
    export let documentId: string

    let { activeGroupStore }  : AuthContext = getContext(ContextTokens.Auth);

    const mutation = useDeleteDocument();

    async function deleteDocument() {
       
        $mutation.mutate({ groupStoreId, projectId, documentId });

        dialogOpen = false;

        //unselect current document
        push(`/gs/${$activeGroupStore?.groupStoreId}/projects/${projectId}/documents`);
    }

    let dialogOpen = false;
</script>

<Dialog.Root bind:open={dialogOpen} >
    <Dialog.Trigger>
        <Button size="sm" variant="outline">
            <Trash2 class="h-3.5 w-3.5" />
        </Button>
    </Dialog.Trigger>
    <Dialog.Content class="max-w-md">
      <Dialog.Header>
        <Dialog.Title>{$t('global.messages.confirm-delete')}</Dialog.Title>
      </Dialog.Header>
        <div>
            {$t('page.projects.documents.confirm-delete')}
        </div>
        <Dialog.Footer class="flex flex-row w-full justify-between">
            <Button variant="destructive"
                on:click={deleteDocument} 
                disabled={$mutation.isLoading}
                >
                {#if $mutation.isLoading}
                    {$t('global.messages.deleting')}...
                {:else}
                    {$t('global.messages.delete')}                    
                {/if}
            </Button>
            <Button variant="secondary" 
                on:click={() => {dialogOpen = false;}}> 
                {$t('global.messages.cancel')}
            </Button>
        </Dialog.Footer>
    </Dialog.Content>
  </Dialog.Root>